import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import clinicService from "../../../../../services/clinic.service";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const VerificationCard = () => {
  const [clinicSettings, setClinicSettings] = useState({});
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const { clinicId } = useParams();

  useEffect(() => {
    setIsLoading(true);
    clinicService
      .getClinicById(clinicId)
      .then((res) => {
        console.log(res.data.verification);
        setClinicSettings(res.data.verification);
        setValue("email", res.data.verification.email);
        setValue("phone", res.data.verification.phone);
        setValue("sms", res.data.verification.sms);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Error while getting Clinic Info", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  }, []);
  
 const sendVerification = (verificationType)=>{
    clinicService.sendVerification(clinicId,verificationType)
    .then(res=>{
        toast.success(verificationType+" Verification Request Sent",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
    })
    .catch(err=>{
        toast.error("Error while sending Verification Request",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
    })
 }
  const onSubmit = (data) => {
    setIsLoading(true);
    for (const key in data) {
      data[key] ? (data[key] = 1) : (data[key] = 0);
    }
    data["clinicId"] = clinicId;
    clinicService
      .updateVerification(clinicId, data)
      .then((res) => {
        setClinicSettings(res.data);
        setIsLoading(false);
        toast.success("Updated Verification", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Error while updating Verification", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  return (
    <div className="col-md-4">
      <div className="card text-white bg-success mb-3">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h5 className="card-title text-white">Verification</h5>
            <div>
              {isEditing ? (
                <button
                  className="btn btn-warning btn-sm mt-3"
                  onClick={() => setIsEditing(false)}
                >
                  <i className="bi bi-x-square bi-sm"></i> Cancel
                </button>
              ) : (
                <button
                  className="btn btn-warning btn-sm mt-3"
                  onClick={() => setIsEditing(true)}
                >
                  <i className="bi bi-pencil-square bi-sm"></i> Edit
                </button>
              )}
            </div>
          </div>

          {isLoading ? (
            <div className="loading"></div>
          ) : isEditing ? (
            <>
            <div className="d-flex justify-content-between">

            
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    {...register("email")}
                  />
                  <label htmlFor="email" className="form-check-label ms-1">
                    {" "}
                    Email{" "}
                  </label>
                </div>
                <div className="form-group mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    {...register("sms")}
                  />
                  <label htmlFor="sms" className="form-check-label ms-1">
                    {" "}
                    SMS
                  </label>
                </div>
                <div className="form-group mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    {...register("phone")}
                  />
                  <label htmlFor="phone" className="form-check-label ms-1">
                    {" "}
                    Phone
                  </label>
                </div>
                <button type="submit" className="btn btn-warning btn-sm">Save</button>
              </form>
                <div className="d-flex flex-column">
                    <button className="btn btn-info btn-sm" onClick={()=>{sendVerification("Email")}}>Send Email Verification</button>
                    <button className="btn btn-info btn-sm mt-2" onClick={()=>{sendVerification("SMS")}}>Send SMS Verification</button>
                    <button className="btn btn-info btn-sm mt-2" onClick={()=>{sendVerification("Phone")}}>Send Phone Verification</button>
                </div>
              </div>
            </>
          ) : (
            <>
              <ul className="list-group">
                <li className="list-group-item">
                  Email
                  {clinicSettings.email ? (
                    <span className="text-success small ms-3">verified</span>
                  ) : (
                    <span className="text-danger small ms-3">not verified</span>
                  )}
                </li>
                <li className="list-group-item">
                  SMS
                  {clinicSettings.sms ? (
                    <span className="text-success small ms-3">verified</span>
                  ) : (
                    <span className="text-danger small ms-3">not verified</span>
                  )}
                </li>
                <li className="list-group-item">
                  Phone
                  {clinicSettings.phone ? (
                    <span className="text-success small ms-3">verified</span>
                  ) : (
                    <span className="text-danger small ms-3">not verified</span>
                  )}
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerificationCard;
